export default __webpack_public_path__ + "static/media/Masters2-1024x1024.9bd05169.png";